"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const getBrowserImageDimensions = (image) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const url = typeof image === "string" ? image : URL.createObjectURL(image);
        if (!url) {
            throw new Error("Must use a valid image");
        }
        const img = new Image();
        img.onload = () => {
            resolve({ width: img.width, height: img.height });
            URL.revokeObjectURL(img.src);
        };
        img.onerror = err => {
            if (typeof image !== "string") {
                URL.revokeObjectURL(url);
            }
            reject(err);
        };
        img.src = url;
    });
});
exports.default = getBrowserImageDimensions;
